// file: src/clients/keycloakService.js
import Keycloak from 'keycloak-js';
import type {KeycloakInfo} from "@/models/stored/user";

const options = {
    url: import.meta.env.VITE_ID_HOST,
    realm: import.meta.env.VITE_ID_REALM,
    clientId: import.meta.env.VITE_ID_CLIENT
}

const keycloak = new Keycloak(options);
let authenticated: boolean;
let store = null;

/**
 * Initializes Keycloak, then run callback. This will prompt you to login.
 *
 * @param onAuthenticatedCallback
 */
async function init(onAuthenticatedCallback: () => void) {
    try {
        console.log("keycloak.service: starting keycloak init");
        authenticated = await keycloak.init({
            onLoad: "check-sso",
            silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`
        })
        console.log("keycloak.service: finished keycloak init");
        //console.log(extractKeycloakInfo());
    } catch (error) {
        console.error("Keycloak init failed")
        console.error(error)
    }
}

/**
 * Logout user
 */
function logout(url: string) {
    console.log("keycloakService: logout")

    keycloak.logout({ redirectUri: url });
}

/**
 * Login user
 */
async function login(url: string) {
    console.log("keycloakService: init Store")

    await keycloak.login({ redirectUri: url });
}

/**
 * Refreshes token
 */
async function refreshToken()    {
    try {
        console.log("keycloakService: refresh token")

        await keycloak.updateToken(480);

        return extractKeycloakInfo();
    } catch (error) {
        console.error('Failed to refresh token');
        if(error)
            console.error(error);
    }
}

function extractKeycloakInfo(): KeycloakInfo{
    return {
        authenticated: keycloak.authenticated,
        token: keycloak.token,
        refreshToken: keycloak.refreshToken,
        username: keycloak.idTokenParsed?.preferred_username as string
    };
}

/** The signed-in person's e-mail address from the ID token, or null when Keycloak sends none. */
function email(): string | null {
    return (keycloak.idTokenParsed?.email as string | undefined) ?? null;
}

export default {
    init,
    logout,
    refreshToken,
    login,
    extractKeycloakInfo,
    email
};